<template>
  <div class="main-footer__language-select">
    <div class="main-footer__language-select-title">
      {{ $tFooter('Language') }}
    </div>
    <div class="select-dropdown">
      <button type="button"
              class="select-dropdown__trigger"
              @click.prevent="onOpen">
        <span class="select-dropdown__trigger-current">{{ currentLocale }}</span>
        <img :src="currentLocaleObject.flag"
             :alt="currentLocale"
             class="select-dropdown__trigger-ico">
        <BaseSvg name="ico-arrow"
                 class="select-dropdown__trigger-arrow"/>
      </button>
      <transition name="dropdown">
        <div v-if="isOpen"
             v-click-out="onClose"
             class="select-dropdown__dropdown">
          <button type="button"
                  class="select-dropdown__close"
                  @click.prevent="onClose"
          >
            <BaseSvg name="ico-close"
                     width=".8rem"
                     height=".8rem"/>
          </button>
          <div class="select-dropdown__options">
            <router-link v-for="item in locales"
                         :key="item.id"
                         :to="getRoute(item)"
                         @click.native="onInput(item)"
                         class="select-dropdown__option">
              <span>{{ item.key }}</span>
              <img :src="item.props.flag"
                   :alt="item.key"
                   class="select-dropdown__trigger-ico">
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FooterLanguagesSelect',
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      locales() {
        const storeLocales = this.$store.state.locales
        const locales = []

        for (let key in storeLocales) {
          locales.push({
            key,
            props: storeLocales[key]
          })
        }

        return locales
      },
      currentLocale() {
        return this.$store.state.currentLocale
      },
      currentLocaleObject() {
        return this.$store.state.locales[this.currentLocale]
      },
      value() {
        return this.locales.find(item => item.key === this.currentLocale)
      }
    },
    methods: {
      onInput(event) {
        const currentLocale = this.locales.find(locale => locale.key === event.key)
        if (currentLocale) {
          this.$store.dispatch('changeCurrentLocale', event.key)
        }
      },
      getOptionText(option) {
        return option.props.name
      },
      getRoute(option) {
        let name = this.$route.name

        if (option.key === 'ua') {
          if (!name.endsWith('-double')) {
            name += '-double'
          }

          return {
            name,
            params: {...this.$route.params, lang: option.key},
            query: {...this.$route.query}
          }
        } else {
          if (name.endsWith('-double')) {
            name = name.replace('-double', '')
          }

          return {
            name,
            params: {...this.$route.params, lang: option.key},
            query: {...this.$route.query}
          }
        }
      },
      onOpen() {
        this.isOpen = true
      },
      onClose() {
        this.isOpen = false
      }
    }
  }
</script>

<style lang="less">

</style>
